import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PopupMission } from 'src/app/shared/components/popup-mission/popup-mission.component';
import { PopupVision } from 'src/app/shared/components/popup-vision/popup-vision.component';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  listClientsCarousel:string[] = [
    "../../../../assets/img/NOSOTROS/Sobre nosotros/03.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/04.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/05.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/06.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/07.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/08.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/09.svg"
  ];
  listAliancesCarousel:string[] = [
    "../../../../assets/img/NOSOTROS/Sobre nosotros/10.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/11.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/12.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/13.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/14.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/15.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/16.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/17.svg",
    "../../../../assets/img/NOSOTROS/Sobre nosotros/18.svg"
  ]
  constructor(private route:Router,
    public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  viewPopupMission(){
    this.dialog.open(PopupMission,{
      height: 'min-content',
      width: '-webkit-fill-available',
      
    })

  }
  viewPopupVision(){
    this.dialog.open(PopupVision,{
      height: 'min-content',
      width: '-webkit-fill-available',
      
    })

  }


}
